import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import WorkflowsView from '../views/WorkflowsView.vue'
import PersonasView from '../views/PersonasView.vue'
import CodesView from '../views/CodesView.vue'
import LoginView from '../views/LoginView.vue'
import ProfileView from '../views/ProfileView.vue'
import ArenaView from '../views/ArenaView.vue'
import ArenaGameView from '../views/ArenaGameView.vue'
import DownloadView from '../views/DownloadView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/workflows',
    name: 'workflows',
    component: WorkflowsView,
  },
  {
    path: '/personas',
    name: 'personas',
    component: PersonasView,
  },
  {
    path: '/codes',
    name: 'codes',
    component: CodesView,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView,
  },
  {
    path: '/arena',
    name: 'arena',
    component: ArenaView,
  },
  {
    path: '/arena/:id',
    name: 'arena-game',
    component: ArenaGameView,
  },
  {
    path: '/download',
    name: 'download',
    component: DownloadView,
  },
  {
    // OAuth callback redirect (handles token in query)
    path: '/auth/callback',
    redirect: to => ({ path: '/login', query: to.query }),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
